import axios from "axios";

export const getCatchReportDeadlines = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/CatchReport/deadlines`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
